import {CustomPreviewProps} from '@domain/kiln-monitoring'

import {KilnShellDrawing} from '@refra/modules/refra-planning/components/KilnOverviewCard/KilnOverviewCardBody/StaticSvg/KilnShellSvg/KilnShellDrawing'
import {ReportMaterialInstallation} from '@refra/modules/refra-planning/types'

export const KilnShellSvg =
  (materialInstallations: ReportMaterialInstallation[]) =>
  ({meterToPixel, kilnLength}: CustomPreviewProps) => {
    return (
      <KilnShellDrawing
        meterToPixel={meterToPixel}
        kilnLength={kilnLength}
        materialInstallations={materialInstallations}
      />
    )
  }
